import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, Select, Checkbox, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { useSaleSoDetailModel, IMaterialDetailModel } from "./saleSoDetailModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IStockStatisticDetail } from "../../../../../stock/statistic/stockStatisticService"
import { YhBut } from "@/components/YhButton";
import { formatNum, formatInt, formatDiscount, formatIntPoint } from "@/utils/utils";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { useDictModel } from "../../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addModalVisible: visible, detailAddForm, detailEditForm,initPgCfg, workDataSource, workPgCfg, addDataSource, searchWorkData, setWorkDataSource, resetWorkloadData, setSearchWorkData, setAddDataSource, workloadData, setAddModalVisible, transformsToDetailList } = useSaleSoDetailModel();
    const { getSelectedDictOne } = useDictModel();
    useEffect(() => {
        workloadData()
    }, [])
    const column = (optype: number) => [
        {
            // title: '序号',
            title: Locale['SN'],
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编号',
            title: Locale['Material Code'],
            width: 100,
            dataIndex: 'materialCode',
            render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale['Material Name'],
            width: 100,
            dataIndex: 'materialName',
            render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 100,
            dataIndex: 'nameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,            
        }, {
            // title: '库存',
            title: Locale['Inventory'],
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            // title: '数量',
            title: Locale['Qty'],
            width: 120,
            dataIndex: 'num',
            editable: true,
        }, {
            // title: '单价',
            title: Locale['Unit Price'],
            width: 120,
            dataIndex: 'lateSalePrice',
            editable: true,
        }, {
            // title: '金额',
            title: Locale['Amount'],
            width: 120,
            dataIndex: 'amount',
        }, {
            // title: '仓库',
            title: Locale['Warehouse'],
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale['Shelf'],
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 120,
            fixed: "right",
            render: (text: any, record: any) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={!!addDataSource.find(item => item.id === record.id)||record.inventoryNum==0}
                />
            ) : (
                    <YhBut
                        type="delete"
                        // txt="删除"
                        txt={Locale['Delete']}
                        click={() => remove(record)}
                    />
                )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, lateSalePrice, inventoryNum } = row
        num = +formatIntPoint(num);
        lateSalePrice = +formatIntPoint(lateSalePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        let newRow = {
            ...row,
            // num: +formatIntPoint(num, inventoryNum, "销售数量≥库存数量"),
            num: +formatIntPoint(num, inventoryNum, Locale["Sales Qty ≥ Inventory Qty"]),
            amount: (num > inventoryNum ? 0 : num * lateSalePrice)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, lateSalePrice, inventoryNum } = row
        num = +formatIntPoint(num);
        lateSalePrice = +formatIntPoint(lateSalePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        let newRow = {
            ...row,
            // num: +formatIntPoint(num, inventoryNum, "销售数量≥库存数量"),
            num: +formatIntPoint(num, inventoryNum, Locale["Sales Qty ≥ Inventory Qty"]),
            amount: (num > inventoryNum ? 0 : num * lateSalePrice)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            // placeholder="商品编码"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Code']}
        />
        {language == "zh-CN" && <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value }) }}
            // placeholder="商品名称"
            onPressEnter={() => workloadData(initPgCfg)}
    
            placeholder={Locale['Material Name']}
        />}
        {language != "zh-CN" &&<Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, nameEn: e.target.value }) }}
            // placeholder="商品名称"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Name En']}
        />}
        <Select
            allowClear
            className="border-r-16 mr-10 ant-select-round"
            value={searchWorkData.brandCode}
            options={getSelectedDictOne(DictCodeEnmu.MATERIAL_BRAND)}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, brandCode: e }); workloadData(initPgCfg,{ ...searchWorkData, brandCode: e }) }}
            style={{ width: "150px" }}
            // placeholder="配件品牌"
            placeholder={Locale['Accessories brand']}
        />
        {/* <Checkbox
            checked={searchWorkData.age ? true : false}
            onChange={(e) => {
                setSearchWorkData({ ...searchWorkData, age: e.target.checked ? 1 : 0  })
            }}
        >{Locale['Marketing Warehouse']}</Checkbox> */}
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">{Locale["Search"]}</Button>
        <Button onClick={() => resetWorkloadData()} shape="round">{Locale["Reset"]}</Button>
    </div>
    const onOK = async () => {
        transformsToDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([])
        setSearchWorkData({})
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="销售单-选择配件"
        title={Locale["Sales Doc -Select Materials"]}
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title={Locale["List of materials to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IStockStatisticDetail>}
                dataSource={workDataSource}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title={Locale["List of selected materials"]}>
            <Table
                rowKey={record => record.id as string}
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IStockStatisticDetail>}
                dataSource={addDataSource}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}